<template>
  <div class="page-content">
    <div class="title">
      <slot />
    </div>
    <div class="list max-w-7xl mx-auto">
      <FileSelector
        v-model="showFileSelector"
        type="assets"
        :subcategory="fileSubcategory"
        @fileUploaded="fileUploaded"
        @selectedFile="fileUploaded"
      />
      <div
        class="input-box"
        :class="{ loading: keySaving == entrie.key }"
        v-for="entrie in formEntries"
        :key="entrie.id + '-' + i"
      >
        <template v-if="keySaving != entrie.key">
          <div class="field key">
            {{ entrie.key }}
          </div>
          <div class="field value" style="min-width: 500px;">
            <template v-if="entrie.dataType == 'string'">
              <textarea
                class="regular clear"
                type="text"
                v-model="entrie.value"
                :disabled="isLocked(entrie.key)"
              />
              <small v-if="isLocked(entrie.key)" class="locked-note">
                Only a superadmin can change this setting.
              </small>
            </template>
            <template v-if="entrie.dataType == 'json'">
              <div class="editor">
                <vueJsonEditor
                  v-model="entrie.value"
                  :show-btns="false"
                  :expandedOnStart="true"
                />
              </div>
            </template>
            <template v-if="entrie.dataType == 'html'">
              <div class="editor">
                <VueEditor
                  class="regular bordered"
                  v-model="entrie.value"
                ></VueEditor>
              </div>
            </template>
            <template v-if="entrie.dataType == 'boolean'">
              <select
                class="default-select"
                name="value"
                v-model="entrie.value"
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </template>
            <template v-if="entrie.dataType == 'double'">
              <input type="number" step="0.01" v-model="entrie.value" />
            </template>
            <template v-if="entrie.dataType == 'color'">
              <input class="w-12" type="color" v-model="entrie.value" />
            </template>
            <template v-if="entrie.dataType == 'select'">
              {{ entrie.options.option }}
              <select
                class="default-select"
                name="value"
                v-model="entrie.value"
              >
                <option
                  v-for="option in entrie.options.options"
                  :value="option.value"
                  :key="option.value"
                  >{{ option.label }}</option
                >
              </select>
            </template>
            <template v-if="entrie.dataType == 'number'">
              <input type="number" v-model="entrie.value" step="0.0000001" />
            </template>
            <template v-if="entrie.dataType == 'image'">
              <img :src="entrie.value" class="img-value" />
              <img
                @click="editImage(entrie.key)"
                src="@/assets/icons/edit.svg"
                alt="edit"
                class="edit-icon"
              />
            </template>
          </div>
          <!-- <div class="field status" v-if="currentUser.role === 'superadmin'">
            <select
              class="default-select"
              name="status"
              v-model="entrie.status"
            >
              <option value="1">Active</option>
              <option value="0">Disabled</option>
            </select>
          </div> -->
          <div class="field actions" v-if="!isLocked(entrie.key)">
            <a
              class="btn btn-success-button"
              v-if="edited(entrie.key)"
              @click="updateEntrie(entrie)"
              >Update</a
            >
            <a
              class="btn btn-dark-button"
              v-if="edited(entrie.key)"
              @click="discard(entrie.key)"
              >Discard</a
            >
          </div>
        </template>
        <template v-else>
          <div class="loading">
            <BaseSmallSpinner />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FileSelector from "@/components/FileSelector.vue";
import vueJsonEditor from "vue-json-editor";
import { VueEditor } from "vue2-editor";
import {
  getSettingsSection,
  updateSetting
} from "@/api/store/SettingsService.js";

// Settings que solo un superadmin puede modificar (el backend también lo exige).
// typesense_orders_key busca en las órdenes, con los datos de los clientes, y
// typesense_server_key lee el documento entero de los productos.
const SUPERADMIN_ONLY_KEYS = [
  "maintenance_sns_topic_arn",
  "typesense_orders_key",
  "typesense_server_key"
];
export default {
  components: {
    vueJsonEditor,
    VueEditor,
    FileSelector
  },
  data() {
    return {
      formEntries: [],
      originalValues: [],
      keySaving: "",
      showFileSelector: false,
      fileSubcategory: null,
      i: 1
    };
  },
  props: {
    settingCategory: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadSettings(this.settingCategory);
  },
  computed: {
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },
    isLocked() {
      return key =>
        SUPERADMIN_ONLY_KEYS.includes(key) &&
        !this.$store.getters["auth/isSuperadmin"];
    },
    edited() {
      return key => {
        let original = this.originalValues.find(x => {
          return x.key == key;
        });
        let actual = this.formEntries.find(x => {
          return x.key == key;
        });
        return !(JSON.stringify(original) == JSON.stringify(actual));
      };
    }
  },
  methods: {
    discard(key) {
      let original = this.originalValues.find(x => {
        return x.key == key;
      });
      let actualIndex = this.formEntries.findIndex(x => {
        return x.key == key;
      });
      this.formEntries[actualIndex].status = original.status;
      this.formEntries[actualIndex].value = original.value;
    },
    fileUploaded(file) {
      let entrieIndex = this.formEntries.findIndex(x => {
        return x.key == this.fileSubcategory;
      });
      this.formEntries[entrieIndex].value = file.s3Url;
    },
    editImage(key) {
      this.fileSubcategory = key;
      this.showFileSelector = true;
    },
    loadSettings(key) {
      getSettingsSection(key)
        .then(res => {
          this.formEntries = res.map(e => {
            let val;
            try {
              val = e.dataType == "json" ? JSON.parse(e.value) : e.value;
            } catch (x) {
              val = e.value;
            }
            return {
              id: e.ID,
              key: e.key,
              dataType: e.dataType,
              value: val,
              options: e.options ? JSON.parse(e.options) : null,
              status: e.status
            };
          });
          this.originalValues = JSON.parse(JSON.stringify(this.formEntries));
        })
        .catch(e => {
          console.log(e);
          alert("error loading data");
        });
    },
    confirmMaintenanceChange(entrie) {
      if (entrie.value == "true") {
        return confirm(
          "⚠️ WARNING: YOU ARE ABOUT TO PUT THE WEBSITE IN MAINTENANCE MODE ⚠️\n\n" +
            "• The ENTIRE public website will stop working for customers: nobody will be able to search, add to cart or place orders.\n" +
            "• Every visitor will see the maintenance page instead of the store.\n" +
            "• The administrator will receive an SNS alert every 10 minutes until maintenance mode is turned off.\n\n" +
            "Are you sure you want to TURN OFF the website?"
        );
      }
      return confirm(
        "You are about to TURN OFF maintenance mode.\n\n" +
          "The website will be available to customers again immediately.\n" +
          "The administrator will be notified of this change by SNS.\n\n" +
          "Do you want to continue?"
      );
    },
    async updateEntrie(entrie) {
      if (
        entrie.key == "maintenance_mode" &&
        !this.confirmMaintenanceChange(entrie)
      ) {
        return;
      }
      this.keySaving = entrie.key;
      let valueFormated =
        entrie.dataType == "json" ? JSON.stringify(entrie.value) : entrie.value;
      let res = await updateSetting(entrie.key, valueFormated, entrie.status);
      if (res.status == "success") {
        let orig = this.originalValues.findIndex(x => {
          return x.key == entrie.key;
        });
        this.originalValues[orig] = JSON.parse(JSON.stringify(entrie));
        this.$store.commit("general/UPDATE_ADMIN_SETTING", {
          key: entrie.key,
          value: valueFormated,
          status: entrie.status
        });
      }
      this.keySaving = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.input-box {
  display: grid;
  grid-template-columns: 200px auto 100px 200px;
  margin: 10px 0px;
  border: 1px solid grey;
  padding: 10px 5px;
  border-radius: 4px;
  min-height: 60px;

  .field {
    position: relative;
    padding: 5px;

    input,
    textarea {
      width: 100%;
      height: 100%;
    }

    input,
    select {
      width: 100%;
    }

    .img-value {
      max-height: 60px;
      margin: 0 auto;
    }

    .locked-note {
      color: #c53030;
    }

    .edit-icon {
      width: 20px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  .actions {
    display: flex;
    flex-direction: row;

    a {
      margin: 1px 0px;
    }
  }

  &.loading {
    display: flex;
    justify-content: center;
  }
}
</style>
